import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap, catchError, timeout } from 'rxjs';

// DEBUG LOG: NoAuthGuard loaded
console.log('[NoAuthGuard] File loaded');

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    // Prevent recursive guard on /sign-out
    if (state.url === '/sign-out') {
        console.log('[NoAuthGuard] Allowing /sign-out to prevent recursion');
        return of(true);
    }
    // Always allow access to /sign-in without redirect
    if (state.url === '/sign-in') {
        console.log('[NoAuthGuard] Allowing /sign-in to prevent redirect loop');
        return of(true);
    }
    console.log('[NoAuthGuard] Checking route:', route, 'state:', state);
    const router: Router = inject(Router);
    const authService = inject(AuthService);

    // Para sign-out, solo permitir si está autenticado
    if (state.url.includes('/sign-out')) {
        return authService.check().pipe(
            switchMap((authenticated) => {
                if (!authenticated) {
                    // Si no está autenticado, redirigir a login
                    router.navigate(['/sign-in']);
                    return of(false);
                }
                return of(true);
            })
        );
    }

    // Check the authentication status con timeout
    return authService.check().pipe(
        timeout(5000),
        switchMap((authenticated) => {
            // Si el usuario está autenticado, redirigir pero SIN limpiar
            if (authenticated) {
                router.navigate(['/home']);
                return of(false);
            }
            // If not authenticated, allow access (no redirect)
            console.log('[NoAuthGuard] Not authenticated, access granted');
            return of(true);
        }),
        catchError((error) => {
            return of(true); // En caso de error, permitir acceso a páginas no autenticadas
        })
    );
};
